// Display-only helpers for the premium panchang modules.
// THE ONE RULE: these NEVER compute astrological values — they only format
// values the external engine already returned (unix→12h in the response's own
// timezone, quality→colour tone). Missing values render the literal "Not available".

export const NA = (v) => (v === 0 || v ? v : "Not available");

export function fmtTime(unix, tz) {
  if (unix === null || unix === undefined || isNaN(unix)) return "Not available";
  try {
    return new Intl.DateTimeFormat("en-US", {
      hour: "numeric", minute: "2-digit", hour12: true, timeZone: tz || "UTC",
    }).format(new Date(unix * 1000));
  } catch { return "Not available"; }
}

export function fmtDateTime(unix, tz) {
  if (unix === null || unix === undefined || isNaN(unix)) return "Not available";
  try {
    return new Intl.DateTimeFormat("en-US", {
      weekday: "short", day: "numeric", month: "short",
      hour: "numeric", minute: "2-digit", hour12: true, timeZone: tz || "UTC",
    }).format(new Date(unix * 1000));
  } catch { return "Not available"; }
}

export const fmtSpan = (a, b, tz) => `${fmtTime(a, tz)} – ${fmtTime(b, tz)}`;

// Map the engine's own quality text to a colour tone. Never rename the text.
export function qtone(q) {
  const s = String(q || "").toLowerCase();
  if (!s) return "neutral";
  if (/(good|favour|auspic|benefic|shubh|amrit|labh|siddhi|sarvartha|strong)/.test(s)) return "good";
  if (/(bad|caution|malefic|unfav|alert|rog|kaal|udveg|yama|rahu|gulika)/.test(s)) return "bad";
  if (/(neutral|mixed|node|char)/.test(s)) return "neutral";
  return "neutral";
}
